<template>
    <a v-if="fileId" class="text-dense" :href="fileDownloadUrl" target="_blank">
        {{ fileName }}
    </a>
    <span v-else>{{ displayValue }}</span>
</template>

<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
    computed: {
    	fileName() {
    		return this.params.data[this.params.colDef.field];
		},
		fileId() {
			return this.params.data[this.params.fileIdField];
		},
        fileDownloadUrl() {
            return fileuploadApi.getPdfUrl(this.fileId);
        },
    	displayValue() {
    		return this.params.value || this.fileName;
		}
    }
};
</script>